var FilterKey = /* @__PURE__ */ ((FilterKey2) => {
  FilterKey2["FullTextSearch"] = "q";
  return FilterKey2;
})(FilterKey || {});
const firstPageDefault = { page: 1, pageSize: 10 };
const queryKeys = {
  page: "page",
  pageSize: "size",
  /**
   * @deprecated
   * <p>Should be removed. Use {@link sortField}</p>
   */
  sort: "sort",
  /**
   * @deprecated
   * <p>Should be removed. Use {@link sortOrder}</p>
   */
  order: "order",
  sortField: "sortField",
  sortOrder: "sortOrder",
  selectedItemId: "selected_item_id",
  jurisdiction: "jurisdiction",
  invalidFilter: "invalid"
};
const baseFilterKeys = ["id", "page", "size", "sortField", "sortOrder", "invalid"];
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["Asc"] = "asc";
  SortOrder2["Desc"] = "desc";
  return SortOrder2;
})(SortOrder || {});
var ServerResponseStatus = /* @__PURE__ */ ((ServerResponseStatus2) => {
  ServerResponseStatus2["Success"] = "Success";
  ServerResponseStatus2["Failed"] = "Failed";
  return ServerResponseStatus2;
})(ServerResponseStatus || {});
class ServiceResponsePayload {
  status;
  statusCode;
  message;
  errors;
  requestPayload;
  responsePayload;
}
class GqlResponse extends ServiceResponsePayload {
}
const maxPageSize = 3e3;
const maxServerDownloadPageSize = 1e4;
var HttpMethod = /* @__PURE__ */ ((HttpMethod2) => {
  HttpMethod2["Post"] = "POST";
  HttpMethod2["Delete"] = "DELETE";
  HttpMethod2["Get"] = "GET";
  HttpMethod2["Put"] = "PUT";
  HttpMethod2["Patch"] = "PATCH";
  return HttpMethod2;
})(HttpMethod || {});
var HttpStatusCode = /* @__PURE__ */ ((HttpStatusCode2) => {
  HttpStatusCode2[HttpStatusCode2["Ok"] = 200] = "Ok";
  HttpStatusCode2[HttpStatusCode2["Created"] = 201] = "Created";
  HttpStatusCode2[HttpStatusCode2["BadRequest"] = 400] = "BadRequest";
  HttpStatusCode2[HttpStatusCode2["Unauthorized"] = 401] = "Unauthorized";
  HttpStatusCode2[HttpStatusCode2["Forbidden"] = 403] = "Forbidden";
  HttpStatusCode2[HttpStatusCode2["NotFound"] = 404] = "NotFound";
  HttpStatusCode2[HttpStatusCode2["InternalServerError"] = 500] = "InternalServerError";
  return HttpStatusCode2;
})(HttpStatusCode || {});
const serverBaseErrorCode = 1e7;
const clientBaseErrorCode = 2e7;
var CustomErrorCodes = ((CustomErrorCodes2) => {
  CustomErrorCodes2[CustomErrorCodes2["FileUploadFailed"] = clientBaseErrorCode + 1] = "FileUploadFailed";
  CustomErrorCodes2[CustomErrorCodes2["FetchRequestFailure"] = clientBaseErrorCode + 2] = "FetchRequestFailure";
  CustomErrorCodes2[CustomErrorCodes2["NetworkRequestFailed"] = clientBaseErrorCode + 3] = "NetworkRequestFailed";
  CustomErrorCodes2[CustomErrorCodes2["InputValidationIncorrectFormat"] = serverBaseErrorCode + 6] = "InputValidationIncorrectFormat";
  CustomErrorCodes2[CustomErrorCodes2["InputValidationValueNotExist"] = serverBaseErrorCode + 27] = "InputValidationValueNotExist";
  CustomErrorCodes2[CustomErrorCodes2["InputValidationNullValue"] = serverBaseErrorCode + 28] = "InputValidationNullValue";
  CustomErrorCodes2[CustomErrorCodes2["InvalidNotificationContractType"] = serverBaseErrorCode + 48] = "InvalidNotificationContractType";
  CustomErrorCodes2[CustomErrorCodes2["UnexpectedTransactionStatus"] = serverBaseErrorCode + 50] = "UnexpectedTransactionStatus";
  CustomErrorCodes2[CustomErrorCodes2["TransactionWithSameIdAlreadyExists"] = serverBaseErrorCode + 56] = "TransactionWithSameIdAlreadyExists";
  CustomErrorCodes2[CustomErrorCodes2["HandledExceptionOccurred"] = serverBaseErrorCode + 58] = "HandledExceptionOccurred";
  CustomErrorCodes2[CustomErrorCodes2["NotEnoughFunds"] = serverBaseErrorCode + 62] = "NotEnoughFunds";
  CustomErrorCodes2[CustomErrorCodes2["StatusChangedButLoginAccessFailed"] = clientBaseErrorCode + 65] = "StatusChangedButLoginAccessFailed";
  CustomErrorCodes2["GeneralLimitExceeded"] = "GeneralLimitExceeded";
  CustomErrorCodes2["UserLimitExceeded"] = "UserLimitExceeded";
  return CustomErrorCodes2;
})(CustomErrorCodes || {});
class RestResponse extends ServiceResponsePayload {
}
export {
  CustomErrorCodes,
  FilterKey,
  GqlResponse,
  HttpMethod,
  HttpStatusCode,
  RestResponse,
  ServerResponseStatus,
  ServiceResponsePayload,
  SortOrder,
  baseFilterKeys,
  clientBaseErrorCode,
  firstPageDefault,
  maxPageSize,
  maxServerDownloadPageSize,
  queryKeys,
  serverBaseErrorCode
};
//# sourceMappingURL=types.js.map
